import axios from 'axios';
import { API_BASE } from '../../scripts/utils/api';

const notifyButton = document.getElementById('notify-button');
const successMessage = document.getElementById('notify__success');
const errorMessage = document.getElementById('notify__error');

if (notifyButton) {
  notifyButton.addEventListener('click', async () => {
    const emailEl = document.getElementById('notify-email');
    if (!emailEl) return;
    const newsletterEl = document.getElementById('Subscribe-newsletter');
    const email = emailEl.value;
    const newsletter = newsletterEl ? (newsletterEl.checked ? true : false) : false;

    const variantSelector = document.getElementById('variant-selector');
    const selectedVariant = variantSelector?.getSelectedVariant();

    try {
      await axios.post(`${API_BASE}/backInStock`, {
        email: email,
        variantId: selectedVariant.id,
        newsletter: newsletter,
      });

      successMessage.style.display = 'block';
      errorMessage.style.display = 'none';
    } catch (error) {
      console.log('🚀 ~ error:', error);
      successMessage.style.display = 'none';
      errorMessage.style.display = 'block';
    }
  });
}
